import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { APP_FOOTER_NAV } from "routes/APP_ROUTES";
import { WiStars } from "react-icons/wi";
import footerImage1 from "../../../assets/images/footerImage1.svg";
import partImage1 from "../../../assets/images/partImage1.png";
import partImage2 from "../../../assets/images/partImage2.png";
import partImage3 from "../../../assets/images/partImage3.png";
import partImage4 from "../../../assets/images/partImage4.png";
import partImage5 from "../../../assets/images/partImage5.png";
import partImage6 from "../../../assets/images/partImage6.png";
import DownAppStore from "../../../assets/images/DownAppStore.png";
import DownGoogImage from "../../../assets/images/DownGoogImage.png";
import { useTranslation } from "react-i18next";

const SOCIAL_LINKS = [
  {
    icon: <i className="bc-i-instagram text-[18px] text-[rgb(255,255,255,0.6)]"></i>,
    links: "#",
  },
  {
    icon: <i className="bc-i-twitter text-[18px] text-[rgb(255,255,255,0.6)]"></i>,
    links: "#",
  },
  {
    icon: <i className="bc-i-facebook text-[18px] text-[rgb(255,255,255,0.6)]"></i>,
    links: "#",
  },
  {
    icon: <i className="bc-i-youtube text-[18px] text-[rgb(255,255,255,0.6)]"></i>,
    links: "#",
  },
  {
    icon: <i className="bc-i-telegram text-[18px] text-[rgb(255,255,255,0.6)]"></i>,
    links: "#",
  },
];

const AppFooter = () => {
  const { t } = useTranslation();
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
  );
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(
        new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
      );
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  return (
    <>
      <style jsx="true">
        {`
          @keyframes hoory-switcher-btn-animation {
            0% {
              background-position: 0 0;
            }
            100% {
              background-position: 200% 0;
            }
          }

          .hoory-switcher-btn-animation {
            color: transparent;
            -webkit-text-fill-color: transparent;
            background: linear-gradient(to right, #fff, #fff3, #fff) 0 0 / 200% 100%;
            -webkit-background-clip: text;
            background-clip: text;
            animation: hoory-switcher-btn-animation 3s infinite linear reverse;
          }
        `}
      </style>

      <footer id="appFooter" className="bg-body md:py-6 sm:px-0 px-2 pb-14 border-t border-[rgb(45,62,97,0.3)] ">
        <div className="container mx-auto">
          <div className="flex flex-col-reverse gap-5 sm:flex-row justify-between py-6">
            <span className="flex gap-3">
              {SOCIAL_LINKS.map((link, index) => {
                return (
                  <a
                    key={`social-link-${index}`}
                    href={link.links}
                    target="_blank"
                    rel="noreferrer"
                    className="bg-[rgb(255,255,255,0.15)] h-[32px] w-[32px] rounded-md flex justify-center items-center hover:bg-[rgb(255,255,255,0.25)]"
                  >
                    {link.icon}
                  </a>
                );
              })}
            </span>
            <span className="flex justify-between gap-4 items-center sm:border-r border-[rgb(45,62,97,0.3)]">
              <span className="flex w-full gap-4 overflow-x-hidden">
                <button className="w-full text-nowrap px-3 sm:hidden text-white text-[14px] border border-[rgb(152,148,148,1)] h-[32px] rounded-[4px]">
                  CONTACT SUPPORT
                </button>
                <button
                  style={{
                    background: "linear-gradient(175deg, #7f0dd8 10%, #a937f0 50%, #c80dd8)",
                  }}
                  className="w-full text-nowrap pl-0 sm:px-5 h-[32px] rounded-lg text-[15px] text-[#ffffffb0] flex items-center justify-center"
                >
                  <WiStars size={30} className="text-[rgb(255,255,255,0.6)]" />
                  <span className="hoory-switcher-btn-animation font-semibold">Ask Hoory AI</span>
                </button>
              </span>
              <button className="sm:block hidden bg-[rgb(25,38,59)] text-[rgb(255,255,255,0.6)] px-5 h-[32px] rounded text-[10px]">
                {currentTime}
              </button>
            </span>
          </div>
          <div className="md:flex justify-center gap-10 flex-wrap border-t border-[rgb(84,84,84,0.3)] sm:py-8 py-3 sm:mb-5">
            {APP_FOOTER_NAV.map((list, index) => (
              <div key={`link-${index}`} className="md:text-left text-center md:m-0 my-4">
                <h3 className="text-[rgb(254,254,254,0.9)] text-[12px] font-bold md:mb-5 mb-2">{list.title}</h3>
                <ul className="flex md:flex-col justify-center md:gap-3">
                  {list.links.map((item, linkIndex) => (
                    <li
                      key={linkIndex}
                      className="text-gray text-[12px] font-semibold md:border-0 border-r border-gray-500 last-of-type:border-0 md:p-0 px-2"
                    >
                      <Link to={item.link}>{item.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <span className="flex justify-center items-center flex-col gap-3 pb-8 text-white/60 text-[11px] font-semibold">
            <h2 className="tracking-[0.2em] md:border-0 border-t border-[rgb(84,84,84,0.3)] w-full text-center md:pt-0 pt-5">
              REGULATIONS & PARTNERS
            </h2>
            <img className="md:h-[55px] h-[40px]" src={footerImage1} alt="" />
          </span>
          <span className="flex justify-center flex-wrap md:gap-12 gap-7 md:opacity-70">
            <img className="md:h-20 h-12" src={partImage1} alt="partner icon" />
            <img className="md:h-20 h-12" src={partImage2} alt="partner icon" />
            <img className="md:h-20 h-12" src={partImage3} alt="partner icon" />
            <img className="md:h-20 h-12" src={partImage4} alt="partner icon" />
            <img className="md:h-20 h-12" src={partImage5} alt="partner icon" />
            <img className="md:h-20 h-12" src={partImage6} alt="partner icon" />
          </span>

          <div className="text-white/40 sm:border-t sm:py-4 border-[rgb(84,84,84,0.3)] leading-[14px] mt-5 ml-3 mr-3 text-[11px] break-words text-center tracking-wider">
            {t("footerDisclaimer")}
          </div>

          <span className="flex gap-3 mt-4 justify-center mx-3 pb-4 border-b border-[rgb(84,84,84,0.3)]">
            <img className="md:h-14 h-8 mb-7" src={DownAppStore} alt="download apple store" />
            <img className="md:h-14 h-8 mb-7" src={DownGoogImage} alt="download google play store" />
          </span>
          <div className="flex md:flex-row flex-col md:justify-between items-center justify-center gap-4 mx-3 py-6">
            <p className="border-2 border-[#e3910a] rounded-3xl text-[10px] w-6 h-6 flex justify-center items-center text-center text-[#e3910a]">
              18+
            </p>
            <p className="text-gray text-[12px] font-semibold">2019 - 2025 3AK3EK</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default AppFooter;
